import styled from "styled-components";
import { Box, Flex } from "../../../assets/ui";

export const StyledCard = styled(Box)`
  padding: 32px 20px 0;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  margin: 32px -8px;
  height: fit-content;

  & > p {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 24px;
    color: #233247;
  }

  & > h3 {
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
    margin-bottom: 16px;
    color: #233247;
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    margin: 0 0 0 30px;
    height: fit-content;
    padding: 50px 26px 0px 45px;
    max-width: 380px;

    & > p {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 40px;
    }
    & > h3 {
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 36px;
    }
  }
`;

export const Block = styled(Box)`
  & > p {
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: #586981;
  }

  & > h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 24px;
    color: #233247;
  }

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    & > h3 {
      font-size: 32px;
      line-height: 40px;
      margin-bottom: 32px;
    }

    & > p {
      margin-bottom: 60px;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const StyleSectionWrapper = styled(Flex)`
  padding: 32px 24px 40px;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    max-width: 1280px;
    margin: 0 auto;
    padding: 64px 80px 30px;
  }
`;
